import SettingsWrapper from '../SettingsWrapper.vue';
import LeadSourcesIndex from './LeadSourcesIndex.vue';
import LeadSourceEditor from './LeadSourceEditor.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

// Espelha pipelines/routes.js - mesma estratégia de SettingsWrapper sem props
// extras; cada tela renderiza seu próprio header via SettingsLayout.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lead-sources'),
      component: SettingsWrapper,
      meta: { permissions: ['administrator'], featureFlag: 'crm' },
      children: [
        {
          path: '',
          name: 'settings_lead_sources',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: LeadSourcesIndex,
        },
        {
          path: ':sourceId',
          name: 'settings_lead_source_edit',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: LeadSourceEditor,
        },
      ],
    },
  ],
};
